import PageRequestModel from "./PageRequestModel";

export default class GetEmployeesWithAccessToProjectRequestModel {
  Page!: PageRequestModel;
  ProjectId!: number;
  Search!: string;
  ShowOnlyActive: boolean = false;
  constructor(obj?: Partial<GetEmployeesWithAccessToProjectRequestModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
